import React from "react";
import PropTypes from "prop-types";
import LabelAndDots from "./LabelAndDots";

const StandardField = ({
  field,
  formData,
  handleChange,
  readOnly,
  validationErrors,
  fieldTransformer,
}) => {
  const isFieldReadOnly = readOnly || field.key === "managementId";
  const errorClass = validationErrors[field.key] ? "border border-red-500" : "";
  return (
    <div className="flex flex-col w-full">
      <div className="flex items-center w-full">
        <label
          className="flex items-center text-sm"
          style={{
            lineHeight: "1.2",
            whiteSpace: "nowrap",
            overflow: "hidden",
            width: "12.5em",
          }}
        >
          <LabelAndDots
            label={field.label}
            tooltip={field.tooltip}
            required={field.required && !!validationErrors[field.key]}
          />
        </label>
        <input
          name={field.key}
          type={field.type || "text"}
          className={`text-sm p-1 flex-grow size-7 ${errorClass} ${
            isFieldReadOnly
              ? "bg-gray-100 cursor-not-allowed"
              : "border border-gray-700"
          }`}
          value={
            fieldTransformer
              ? fieldTransformer(formData[field.key])
              : formData[field.key] || ""
          }
          onChange={handleChange}
          readOnly={isFieldReadOnly}
          style={
            isFieldReadOnly ? { pointerEvents: "none", userSelect: "none" } : {}
          }
        />
      </div>
      {validationErrors[field.key] && (
        <div className="text-red-500 text-sm mt-1 text-end">
          {validationErrors[field.key]}
        </div>
      )}
    </div>
  );
};

StandardField.propTypes = {
  field: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  validationErrors: PropTypes.object,
  fieldTransformer: PropTypes.func,
};

export default StandardField;
